import { render } from "./ReceivePetty.vue?vue&type=template&id=0dcb95c4&scoped=true"
import script from "./ReceivePetty.vue?vue&type=script&lang=js"
export * from "./ReceivePetty.vue?vue&type=script&lang=js"

import "./ReceivePetty.vue?vue&type=style&index=0&id=0dcb95c4&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb95c4"]])

export default __exports__